module.exports = __webpack_public_path__ + "static/testimfamily-9176888fff99bf0497e00fb0f6d17236.png";